document.addEventListener("DOMContentLoaded", function () {
  const faqItems = document.querySelectorAll(".faq-details");

  faqItems.forEach((item) => {
    item.addEventListener("toggle", function () {
      if (item.open) {
        // Close the others (will animate closed thanks to CSS)
        faqItems.forEach((other) => {
          if (other !== item) other.removeAttribute("open");
        });
      }
    });
  });
});